import { Compass } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button, Card, EmptyState } from '@/components/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Card>
      <EmptyState
        icon={Compass}
        title="Página não encontrada"
        description="O endereço não existe ou o conteúdo foi removido."
        action={<Button onClick={() => navigate('/')}>Voltar ao início</Button>}
      />
    </Card>
  );
}
